export enum ConsentState {
    ACCEPTED = "accepted",
    DECLINED = "declined",
    PENDING = "pending",
}
